import { defineStore } from "pinia";
import _ from "lodash";
import router from "@/employee/routes";
import {
  BalanceTransferMethod,
  BalanceTransferState,
  BalanceTransferStepKey,
  RolloverBalanceTransferFormRequest,
  TrusteeToTrusteeBalanceTransferFormRequest
} from "@/shared/types";
import {
  generateRolloverBalanceTransferForm,
  generateTrusteeToTrusteeBalanceTransferForm
} from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { OnboardingBalanceTransfer as BalanceTransferRouteName } from "@/employee/route-names";

export const initialState: BalanceTransferState = {
  transferMethod: BalanceTransferMethod.None,
  rolloverDetails: {
    amount: 0
  },
  trusteeToTrusteeDetails: {
    trusteeAccountNumber: "",
    transferEntireBalance: false,
    transferPartialBalance: false,
    amount: 0
  }
};

export function goToStep (stepKey?: BalanceTransferStepKey) {
  return router.push({
    name: BalanceTransferRouteName,
    params: {
      stepKey
    }
  });
}

export function goToStart () {
  return goToStep();
}

export const useBalanceTransferStore = defineStore("balanceTransfer", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    generateTrusteeToTrusteeBalanceTransferForm () {
      let transferEntireBalance: boolean = null;

      if (this.trusteeToTrusteeDetails.transferEntireBalance) {
        transferEntireBalance = true;
      } else if (this.trusteeToTrusteeDetails.transferPartialBalance) {
        transferEntireBalance = false;
      }

      const request: TrusteeToTrusteeBalanceTransferFormRequest = {
        trusteeAccountNumber: this.trusteeToTrusteeDetails.trusteeAccountNumber,
        transferEntireBalance,
        amount: this.trusteeToTrusteeDetails.amount > 0 ? this.trusteeToTrusteeDetails.amount : null
      };

      return generateTrusteeToTrusteeBalanceTransferForm(request)
        .then(response => response.data)
        .catch(error => storeHelper.handleError({ error, rethrow: true }));
    },
    generateRolloverBalanceTransferForm () {
      const request: RolloverBalanceTransferFormRequest = {
        amount: this.rolloverDetails.amount > 0 ? this.rolloverDetails.amount : null
      };

      return generateRolloverBalanceTransferForm(request)
        .then(response => response.data)
        .catch(error => storeHelper.handleError({ error, rethrow: true }));
    },
    clearState () {
      this.transferMethod = BalanceTransferMethod.None;
      this.rolloverDetails = { amount: 0 };
      this.trusteeToTrusteeDetails = {
        trusteeAccountNumber: "",
        transferEntireBalance: false,
        transferPartialBalance: false,
        amount: 0
      };
    }
  }
});
